import instance from "./instance";
export const getCredits = () => {
    return instance.get(`/credits`)
        .then((response) => ({ response }))
        .catch((error) => ({ error }));
};
